/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { groupSchema } from "./groupSchema.ts";

export const groupsListPathOrgUnitIdSchema = z.uuid();

export const groupsListQueryUseHotMenuSchema = z.boolean().optional().default(true).describe("Брать группу из hot_menu, если она там есть");

export const groupsListStatus200Schema = z.array(groupSchema);

export const groupsListResponseSchema = groupsListStatus200Schema;
